import BaseMessage from '../BaseMessage';

class Execute extends BaseMessage {
  constructor(params) {
    let id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    super();
    this.method = 'blade.execute';
    let tmp;

    if (params.hasOwnProperty('result')) {
      tmp = {
        result: params
      };
    } else {
      tmp = {
        method: this.method,
        params
      };
    }

    if (id) {
      tmp.id = id;
    }

    this.buildRequest(tmp);
  }

}

export { Execute };